import React from "react";

type Iconprops = React.SVGProps<SVGSVGElement>;

export const JAIcon: React.FC<Iconprops> = (props) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M9.5 19C14.7467 19 19 14.7467 19 9.5C19 4.25329 14.7467 0 9.5 0C4.25329 0 0 4.25329 0 9.5C0 14.7467 4.25329 19 9.5 19Z" fill="#F5F5F5" />
    <path d="M9.50001 13.3C11.5987 13.3 13.3 11.5987 13.3 9.5C13.3 7.40131 11.5987 5.7 9.50001 5.7C7.40133 5.7 5.70001 7.40131 5.70001 9.5C5.70001 11.5987 7.40133 13.3 9.50001 13.3Z" fill="#ED4C5C" />
  </svg>
);

export default JAIcon;
